import request from '@/src/utils/request'

export const getPriceRules = async (productId, params = {}) => {
  const query = {
    page: params.page,
    perPage: params.perPage,
    state: params.state,
    type: params.type,
    operator: params.operator,
    isExpired: params.isExpired,
  }

  Object.keys(query).forEach((key) => {
    if (query[key] === '' || query[key] === null || query[key] === undefined) {
      delete query[key]
    }
  })

  return await request.get(`/admin/hotel/${productId}/price-rules`, {
    params: query,
  })
}

export const createPriceRule = async (productId, data) => {
  return await request.post(`/admin/hotel/${productId}/price-rule`, data)
}

export const updatePriceRule = async (productId, priceRuleId, data) => {
  return await request.patch(`/admin/hotel/${productId}/price-rule/${priceRuleId}`, data)
}

export const deletePriceRule = async (productId, priceRuleId) => {
  return await request.delete(`/admin/hotel/${productId}/price-rule/${priceRuleId}`)
}

export const getPriceRuleDetail = async (productId, priceRuleId) => {
  return await request.get(`/admin/hotel/${productId}/price-rule/${priceRuleId}`)
}
